module.exports = __webpack_public_path__ + "static/media/energy_mgmt.42eca4fa.png";